interface Props {
  small?: boolean;
  white?: boolean;
  clicable?: boolean;
}
const SvgEye: React.FC<Props> = ({ small, white, clicable }) => {
  return (
    <svg
      style={{
        transform: small ? "scale(0.67)" : "",
        cursor: clicable ? "pointer" : "default",
        // The white variant sits on a photo overlay — keep it white in dark mode.
        color: white ? "var(--on-accent)" : undefined,
      }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon" clipPath="url(#clip0_24258_3054)">
        <path
          id="Vector"
          d="M8.99484 3.375C4.74999 3.375 1.0098 6.31722 0.0175497 10.1726C-0.0195521 10.3171 0.00227686 10.4705 0.0782346 10.5989C0.154192 10.7273 0.278057 10.8203 0.422579 10.8574C0.567101 10.8945 0.720443 10.8727 0.848871 10.7967C0.977298 10.7208 1.07029 10.5969 1.10739 10.4524C1.96239 7.13028 5.2747 4.5 8.99484 4.5C12.715 4.5 16.0378 7.13121 16.8925 10.4524C16.9297 10.5969 17.0226 10.7208 17.1511 10.7967C17.2795 10.8727 17.4328 10.8945 17.5774 10.8574C17.7219 10.8203 17.8458 10.7273 17.9217 10.5989C17.9977 10.4705 18.0195 10.3171 17.9824 10.1726C16.9899 6.31629 13.2397 3.375 8.99484 3.375ZM9.0007 6.375C7.00568 6.375 5.37668 8.004 5.37668 9.99902C5.37668 11.994 7.00568 13.6238 9.0007 13.6238C10.9957 13.6238 12.6255 11.994 12.6255 9.99902C12.6255 8.004 10.9957 6.375 9.0007 6.375Z"
          className={`${white ? "fill-current" : "fill-primary"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_24258_3054">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEye;
